<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            Catalog
            &rarr;
            <span v-if="$route.name.indexOf('product') !== -1">
                            <span v-if="$route.name !== 'products'">
                                <router-link :to="{ name: 'products'}">Products</router-link>
                                <span>&rarr;</span>
                                <span v-if="$route.name === 'product'">{{ getProduct($route.params.id).name }}</span>
                                <span v-else>New Product</span>
                            </span>
                            <span v-else>Products</span>
                        </span>
            <span v-if="$route.name.indexOf('bundle') !== -1">
                            <span v-if="$route.name !== 'bundles'">
                                <router-link :to="{ name: 'bundles'}">Bundles</router-link>
                                <span>&rarr;</span>
                                <span v-if="$route.name === 'bundle'">{{ getBundle($route.params.id).name }}</span>
                                <span v-else>New Bundle</span>
                            </span>
                            <span v-else>Bundles</span>
                        </span>
            <span v-if="$route.name.indexOf('categor') !== -1">
                            <span v-if="$route.name !== 'categories'">
                                <router-link :to="{ name: 'categories'}">Categories</router-link>
                                <span>&rarr;</span>
                                <span v-if="$route.name === 'category'">{{ getCategory($route.params.id).name }}</span>
                                <span v-else>New Category</span>
                            </span>
                            <span v-else>Categories</span>
                        </span>
            <span v-if="$route.name.indexOf('discount') !== -1">
                            <span v-if="$route.name !== 'discounts'">
                                <router-link :to="{ name: 'discounts'}">Discounts</router-link>
                                <span>&rarr;</span>
                                <span v-if="$route.name === 'discount'">{{ getDiscount($route.params.id).name }}</span>
                                <span v-else>New Discount</span>
                            </span>
                            <span v-else>Discounts</span>
                        </span>
            <span v-if="$route.name.indexOf('item') !== -1">
                            <span v-if="$route.name !== 'items'">
                                <router-link :to="{ name: 'items'}">Items</router-link>
                                <span>&rarr;</span>
                                <span v-if="$route.name === 'item'">{{ getItem($route.params.id).name }}</span>
                                <span v-else>New Item</span>
                            </span>
                            <span v-else>Items</span>
                        </span>
            <span v-if="$route.name.indexOf('tag') !== -1">
                            <span v-if="$route.name !== 'tags'">
                                <router-link :to="{ name: 'tags'}">Tags</router-link>
                                <span>&rarr;</span>
                                <span v-if="$route.name === 'tag'">{{ getTag($route.params.id).name }}</span>
                                <span v-else>New Tag</span>
                            </span>
                            <span v-else>Tags</span>
                        </span>
            <span v-if="$route.name.indexOf('month') !== -1">Months</span>
            <span v-if="$route.name.indexOf('referral_source') !== -1">Referral Sources</span>
          </h1>
        </div>
      </div>
    </section>
    <div class="container">
      <div class="tabs">
        <ul>
          <router-link tag="li" :to="{ name: 'products' }"><a>Products</a></router-link>
          <router-link tag="li" :to="{ name: 'bundles' }"><a>Bundles</a></router-link>
          <router-link tag="li" :to="{ name: 'categories' }"><a>Categories</a></router-link>
          <router-link tag="li" :to="{ name: 'items' }"><a>Items</a></router-link>
          <router-link tag="li" :to="{ name: 'tags' }"><a>Tags</a></router-link>
          <router-link tag="li" :to="{ name: 'months' }"><a>Months</a></router-link>
          <router-link tag="li" :to="{ name: 'discounts' }"><a>Discounts</a></router-link>
          <router-link tag="li" :to="{ name: 'referral_sources' }"><a>Referral Sources</a></router-link>
        </ul>
      </div>
      <div>
        <transition mode="out-in" name="fade">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'catalog',
  data() {
    return {}
  },
  computed: mapGetters([
    'products',
    'bundles',
    'categories',
    'discounts',
    'items',
    'tags',
  ]),
  methods: {
    getProduct(id) {
      return this.products.find(find => find.id === parseInt(id))
    },
    getBundle(id) {
      return this.bundles.find(find => find.id === parseInt(id))
    },
    getCategory(id) {
      return this.categories.find(find => find.id === parseInt(id))
    },
    getDiscount(id) {
      return this.discounts.find(find => find.id === parseInt(id))
    },
    getItem(id) {
      return this.items.find(find => find.id === parseInt(id))
    },
    getTag(id) {
      return this.tags.find(find => find.id === parseInt(id))
    },
  }
}
</script>



// WEBPACK FOOTER //
// Catalog.vue?00b3b86c